import Vue from 'vue'
import App from './App.vue'
import router from './router';
import Element from 'element-ui'
import { InfiniteScroll } from 'element-ui' // 引入无限滚动组件
import VueParticles from 'vue-particles'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/theme.css'; // 门户全局主题（必须在 element 样式之后引入才能覆盖）
import axios from 'axios'
import store from './store'
import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css';

Vue.config.productionTip = false
Vue.use(VueParticles) // 粒子特效背景
Vue.use(Element,{})
Vue.use(InfiniteScroll) // 使用无限滚动组件
Vue.use(MuseUI)

Vue.prototype.$axios = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
